<form [formGroup]="dateRangeForm" (input)="onChange()" (change)="onChange()">
    <input #easepick 
        id="datepicker"
        [value]="this.value"
        class="input input-bordered input-md w-40" />  
</form>